import { ApiProvider } from './context/Api.context';
import { Environment } from './env/Environment';
import { routes } from './routes';
import { authInterceptor } from './utils/auth/auth-interceptor';
import {
  authResponseError,
  authResponseSuccess,
} from './utils/auth/auth-response-interceptor';
import { getBlurbCoreUrl, setupClients } from '@rpi/api';
import { Util } from '@rpi/core-utils';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

// TODO: REMOVE!!!
console.log('[TEMPORARY] Environment', Environment);

export const PUBLIC_URL = Util.createPublicUrl(
  Environment.BASE_URL,
  Environment.IS_DEV,
);

setupClients(({ cornerstone }) => {
  cornerstone.defaults.baseURL = getBlurbCoreUrl({
    hostname: window.location.hostname,
    blurbCoreUrl: Environment.API.URL.BLURBCORE,
    f5BlurbCoreUrl: Environment.API.URL.F5_BLURBCORE,
  });
  cornerstone.interceptors.request.use(authInterceptor);
  cornerstone.interceptors.response.use(authResponseSuccess, authResponseError);
});

const router = createBrowserRouter(routes);

export default function App() {
  return (
    <ApiProvider>
      <RouterProvider router={router} fallbackElement={<div>loading...</div>} />
    </ApiProvider>
  );
}
